import React, { useEffect, useState } from 'react';
import { useApolloClient, useLazyQuery } from '@apollo/react-hooks';
import { Marker, MarkerClusterer, InfoWindow } from '@react-google-maps/api';
import { gqlGet, gqlGetAggr } from './graphql';
import Spiderfy from './spiderfy';

/* ---------------- Markers ------------------ */
export const CollectionPointsMarkers = ({ bounds, zoom, onMarkerClick, isRechargeGreece, filter = 'all' }) => {
  // Region
  if (zoom < 11)
    return (
      <CollectionPointsMarkersAggr
        bounds={bounds}
        zoom={zoom}
        grouping={'Region'}
        onMarkerClick={onMarkerClick}
        filter={filter}
      />
    );
  // Sub Region
  else if (zoom < 14)
    return (
      <CollectionPointsMarkersAggr
        bounds={bounds}
        zoom={zoom}
        grouping={'SubRegion'}
        onMarkerClick={onMarkerClick}
        filter={filter}
      />
    );
  // PostalCode
  else if (zoom < 17)
    return (
      <CollectionPointsMarkersAggr
        bounds={bounds}
        zoom={zoom}
        grouping={'PostalCode'}
        onMarkerClick={onMarkerClick}
        filter={filter}
      />
    );
  // Collection Point
  else
    return (
      <CollectionPointsMarkersDetail
        isRechargeGreece={isRechargeGreece}
        bounds={bounds}
        zoom={zoom}
        onMarkerClick={onMarkerClick}
        filter={filter}
      />
    );
};

/* ---------------- Markers Detail ------------------ */
const SPIDERFY = true;
export const CollectionPointsMarkersDetail = ({ bounds, zoom, onMarkerClick, isRechargeGreece, filter = 'all' }) => {
  console.log('CollectionPointsMarkersDetail');
  const client = useApolloClient();

  const [activeMarker, setActiveMarker] = useState(null);
  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  const [markers, setMarkers] = useState([]);

  useEffect(() => {
    const asyncFunc = async () => {
      console.log('fetchMarkers');
      const rawMarkers = await fetchData(client, bounds);
      if (!rawMarkers || rawMarkers.length === 0) {
        setMarkers([]);
        return;
      }
      const visibleMarkers = rawMarkers.filter((m) => {
        if (filter === 'all') return true;
        if (filter === 'recharge') return !!m.isRechargePoint;
        if (filter === 'nonrecharge') return !m.isRechargePoint;
        return true;
      });

      setMarkers(visibleMarkers);
    };
    asyncFunc();
  }, [bounds, zoom, onMarkerClick, isRechargeGreece, filter]);

  const constructMarkers = async (clusterer) => {
    console.log('constructMarkers', markers.length);

    const googleMarkers = markers.map((cp) => {
      return (
        <Marker
          key={cp.id}
          // label={zoom > 17 ? cp.label : ''}
          // options={{
          //   collisionBehavior: 'OPTIONAL_AND_HIDES_LOWER_PRIORITY',
          //   //google.maps.CollisionBehavior.REQUIRED_AND_HIDES_OPTIONAL,
          // }}
          title={cp.title}
          position={cp.position}
          icon={{
            // url: isRechargeGreece && cp.isRechargePoint ? './recharge.png' : './favicon.png',
            url: cp.isRechargePoint ? './recharge.png' : './favicon.png',
            scaledSize: new google.maps.Size(36, 36),
            //origin: new google.maps.Point(8, 12),
            labelOrigin: new google.maps.Point(16, 48), // το κείμενο απο κάτω
          }}
          label={
            zoom >= 18
              ? {
                  text: cp.label,
                  fontSize: zoom > 19 ? '16px' : '14px',
                  fontFamily: '"Courier New", Courier,Monospace',
                  fontWeight: 'bold',
                  color: 'darkgreen',
                }
              : null
          }
          clusterer={clusterer}
          onClick={(e) => {
            onMarkerClick(e.latLng); // Zoom
            handleActiveMarker(cp.id); // Show Info Window
          }}
        >
          {activeMarker === cp.id ? (
            <InfoWindow onCloseClick={() => setActiveMarker(null)}>
              <div className="poi-info-window">
                <div className="title">
                  {cp.collectionpointName} <small style={{ color: 'gray' }}>({cp.id})</small>
                </div>
                <div className="view-link">{cp.collectionpointProfession}</div>
                <div className="address-line">{cp.collectionpointAddress}</div>
              </div>
            </InfoWindow>
          ) : null}
        </Marker>
      );
    });
    console.log('return googleMarkers', googleMarkers[0]);
    return googleMarkers;
  };

  if (!markers || markers.length === 0) return null;
  else if (SPIDERFY)
    return (
      <MarkerClusterer averageCenter enableRetinaIcons gridSize={60} maxZoom={17}>
        {(clusterer) => {
          //   return <Spiderfy>{constructMarkers(clusterer)}</Spiderfy>;
          return (
            <Spiderfy>
              {markers.map((cp) => (
                <Marker
                  key={cp.id}
                  // label={zoom > 17 ? cp.label : ''}
                  // options={{
                  //   collisionBehavior: 'OPTIONAL_AND_HIDES_LOWER_PRIORITY',
                  //   //google.maps.CollisionBehavior.REQUIRED_AND_HIDES_OPTIONAL,
                  // }}
                  title={cp.title}
                  position={cp.position}
                  icon={{
                    // url: isRechargeGreece && cp.isRechargePoint ? './recharge.png' : './favicon.png',
                    url: cp.isRechargePoint ? './recharge.png' : './favicon.png',
                    scaledSize: new google.maps.Size(36, 36),
                    //origin: new google.maps.Point(8, 12),
                    labelOrigin: new google.maps.Point(16, 48), // το κείμενο απο κάτω
                  }}
                  label={
                    zoom >= 18
                      ? {
                          text: cp.label,
                          fontSize: zoom > 19 ? '16px' : '14px',
                          fontFamily: '"Courier New", Courier,Monospace',
                          fontWeight: 'bold',
                          color: 'darkgreen',
                        }
                      : null
                  }
                  clusterer={clusterer}
                  onClick={(e) => {
                    onMarkerClick(e.latLng); // Zoom
                    handleActiveMarker(cp.id); // Show Info Window
                  }}
                >
                  {activeMarker === cp.id ? (
                    <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                      <div className="poi-info-window">
                        <div className="title">
                          {cp.collectionpointName} <small style={{ color: 'gray' }}>({cp.id})</small>
                        </div>
                        <div className="view-link">{cp.collectionpointProfession}</div>
                        <div className="address-line">{cp.collectionpointAddress}</div>
                      </div>
                    </InfoWindow>
                  ) : null}
                </Marker>
              ))}{' '}
            </Spiderfy>
          );
        }}
      </MarkerClusterer>
    );
  else return <div>$$$</div>;
};

/* ------------------ Fetch Data ---------------------------- */
interface LatLngLiteral {
  lat: number;
  lng: number;
}
interface MarkerData {
  id: number;
  label: string;
  title: string;
  position: LatLngLiteral;
  collectionpointName?: string;
  collectionpointProfession?: string;
  collectionpointAddress?: string;
  isRechargePoint?: boolean;
}

async function fetchData(client, bounds) {
  if (!bounds || !bounds.fromLat) return;
  try {
    const where = {
      $and: [
        { latitude: { $gte: bounds.fromLat } },
        { latitude: { $lte: bounds.tillLat } },
        { longitude: { $gte: bounds.fromLng } },
        { longitude: { $lte: bounds.tillLng } },
      ],
    };
    const variables = {
      where: JSON.stringify(where),
      limit: 1000,
    };
    const result = await client.query({
      query: gqlGet,
      fetchPolicy: 'network-only',
      variables,
    });

    const newMarkers = result.data.getCollectionpointGeocoding?.data?.map((rec) => {
      let label = `${rec.collectionpoint.name}`;
      if (label.length > 10) label = label.substring(0, 7) + '...';
      return {
        id: rec.collectionpoint.id,
        label: label,
        title: `${rec.collectionpoint?.name}\n${rec.collectionpoint.profession?.name}\n${rec.collectionpoint?.addressLine1}, ${rec.collectionpoint?.postalCode}, ${rec.collectionpoint?.addressCity}`,
        collectionpointName: rec.collectionpoint?.name,
        collectionpointProfession: rec.collectionpoint?.profession?.name,
        collectionpointAddress: `${rec.collectionpoint.addressLine1}, ${rec.collectionpoint.postalCode}, ${rec.collectionpoint.addressCity}`,
        position: {
          lat: parseFloat(rec.latitude),
          lng: parseFloat(rec.longitude),
        },
        isRechargePoint: rec.collectionpoint.isRechargePoint,
      };
    });

    return newMarkers;
  } catch (err) {
    console.error('useFetchData error', err);
  }
}

function useFetchData(bounds) {
  // Markers
  const [markers, setMarkers] = useState<Array<MarkerData>>();

  // Load Data
  const [get] = useLazyQuery(gqlGet, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      const newMarkers = data.getCollectionpointGeocoding?.data.map((rec) => {
        let label = `${rec.collectionpoint.name}`;
        if (label.length > 10) label = label.substring(0, 7) + '...';
        return {
          id: rec.collectionpoint.id,
          label: label,
          title: `${rec.collectionpoint.name}\n${rec.collectionpoint.profession.name}\n${rec.collectionpoint.addressLine1}, ${rec.collectionpoint.postalCode}, ${rec.collectionpoint.addressCity}`,
          collectionpointName: rec.collectionpoint?.name,
          collectionpointProfession: rec.collectionpoint?.profession?.name,
          collectionpointAddress: `${rec.collectionpoint.addressLine1}, ${rec.collectionpoint.postalCode}, ${rec.collectionpoint.addressCity}`,
          position: {
            lat: parseFloat(rec.latitude),
            lng: parseFloat(rec.longitude),
          },
          isRechargePoint: rec.collectionpoint.isRechargePoint,
        };
      });
      setMarkers(newMarkers);
      console.log('useFetchData', newMarkers.length);
    },
  });

  useEffect(() => {
    if (!bounds || !bounds.fromLat) return;
    const where = {
      $and: [
        { latitude: { $gte: bounds.fromLat } },
        { latitude: { $lte: bounds.tillLat } },
        { longitude: { $gte: bounds.fromLng } },
        { longitude: { $lte: bounds.tillLng } },
      ],
    };
    get({
      variables: {
        where: JSON.stringify(where),
        limit: 1000,
      },
    });
  }, [bounds, get]);

  return { markers };
}

/* ---------------- Markers Aggr Detail ------------------ */
export const CollectionPointsMarkersAggr = ({ bounds, zoom, grouping, onMarkerClick, filter = 'all' }) => {
  const client = useApolloClient();
  useEffect(() => {
    console.log('CollectionPointsMarkersAggr bounds', bounds);
  }, [bounds]);
  //   return null;

  const [markers, setMarkers] = useState([]);
  useEffect(() => {
    const asyncFunc = async () => {
      const markers = await fetchDataAggr(client, bounds, grouping, filter);
      if (!markers || markers.length === 0) {
        setMarkers([]);
        return;
      }
      setMarkers(markers);
      //   const visible = markers.filter((m) => {
      //     if (filter === 'all') return true;
      //     if (filter === 'recharge') return !!m.isRechargePoint;
      //     if (filter === 'nonrecharge') return !m.isRechargePoint;
      //     return true;
      //   });
      //   if (!visible || visible.length === 0) setMarkers([]);
      //   else setMarkers(visible);
    };
    asyncFunc();
  }, [bounds, zoom, grouping, onMarkerClick, filter]);

  console.log('CollectionPointsMarkersAggr length', markers.length);
  if (!markers) return null;
  else
    return (
      <>
        {markers.map((cp) => {
          return (
            <Marker
              key={cp.id}
              label={cp.label}
              title={cp.title}
              position={cp.position}
              icon={{
                // url: './favicon.png',
                // url: isRechargeGreece && cp.isRechargePoint ? './recharge.png' : './favicon.png',
                url: filter === 'recharge' ? './recharge.png' : './favicon.png',
                scaledSize: new google.maps.Size(36, 36),
              }}
              onClick={(e) => {
                onMarkerClick(e.latLng);
              }}
            />
          );
        })}
      </>
    );
};
/* ------------------ Fetch Aggr Data ---------------------------- */
async function fetchDataAggr(client, bounds, grouping, filter) {
  if (!bounds || !bounds.fromLat) return;
  try {
    let isRechargePoint = null;
    if (filter === 'all') isRechargePoint = null;
    else if (filter === 'recharge') isRechargePoint = true;
    if (filter === 'nonrecharge') isRechargePoint = false;

    const result = await client.query({
      query: gqlGetAggr,
      fetchPolicy: 'network-only',
      variables: {
        grouping: grouping,
        fromLat: bounds.fromLat,
        tillLat: bounds.tillLat,
        fromLon: bounds.fromLng,
        tillLon: bounds.tillLng,
        isRechargePoint: isRechargePoint,
      },
    });

    const newMarkers = result.data.getCollectionpointGeocodingAggrV2?.map((rec) => {
      return {
        id: rec.name,
        label: `${rec.value}`,
        title: `${grouping === 'PostalCode' ? 'Τ.Κ. ' : ''}${rec.name}\n${rec.value} σημεία`,
        position: {
          lat: parseFloat(rec.latitude),
          lng: parseFloat(rec.longitude),
        },
      };
    });

    return newMarkers;
  } catch (err) {
    console.error('useFetchDataAggr error', err);
  }
}

function useFetchDataAggr(bounds, grouping) {
  // Markers
  const [markers, setMarkers] = useState<Array<MarkerData>>();

  // Load Data
  const [get] = useLazyQuery(gqlGetAggr, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      const newMarkers = data.getCollectionpointGeocodingAggr?.map((rec) => {
        return {
          id: rec.name,
          label: `${rec.value}`,
          title: `${grouping === 'PostalCode' ? 'Τ.Κ. ' : ''}${rec.name}\n${rec.value} σημεία`,
          position: {
            lat: parseFloat(rec.latitude),
            lng: parseFloat(rec.longitude),
          },
        };
      });
      setMarkers(newMarkers);
      console.log('useFetchData Aggr', grouping, newMarkers.length);
    },
  });

  useEffect(() => {
    if (!bounds || !bounds.fromLat) return;
    get({
      variables: {
        grouping: grouping,
        fromLat: bounds.fromLat,
        tillLat: bounds.tillLat,
        fromLon: bounds.fromLng,
        tillLon: bounds.tillLng,
      },
    });
  }, [bounds, get, grouping]);

  return { markers };
}
